// REMIX HMR BEGIN
import * as __hmr__ from "remix:hmr";
if (import.meta) {
import.meta.hot = __hmr__.createHotContext(
//@ts-expect-error
"app/utils/constants.ts"
);
import.meta.hot.lastModified = "1743646620773.504";
}
// REMIX HMR END

export const ACCESS_AUTHENTICATED_USER_EMAIL_HEADER =
	'Cf-Access-Authenticated-User-Email'

export const SENTRY_DSN =
	// @ts-ignore
	typeof __SENTRY_DSN__ !== 'undefined' ? __SENTRY_DSN__ : undefined

export const RELEASE: string | undefined =
	// @ts-ignore
	typeof __RELEASE__ !== 'undefined' ? __RELEASE__ : undefined
